import React from 'react';
import { Box, Text } from 'grommet';
import SHDImage from '@ui/Image/SHDImage';
import { getOrdinalSuffix } from '@helpers/utils/formatUtils';

const InninngTracker = ({ inning = 1, half = 'top' }) => {
  return (
    <Box
      className="inning-tracker"
      direction="row"
      justify="center"
      align="center"
    >
      <InningCaretIcon half={half} />
      <Text size="12px" margin={{ left: '4px' }}>
        {`${inning}${getOrdinalSuffix(inning)}`}
      </Text>
    </Box>
  );
};

export default InninngTracker;

const InningCaretIcon: React.FC<{ half: string }> = ({ half }) => (
  <SHDImage
    alt={`caret-${half} icon`}
    className="inning-caret-icon"
    color="black"
    isSquare={false}
    src={`/icons/livecard_caret_${half}.svg`}
    width={8}
  />
);
